import React from 'react';
import { IconCircleI } from '@hawkins/assets';
import { Dimensions } from '@hawkins/variables';
import {
  Divider,
  DropdownOption,
  Card,
  CardBody,
  CardHeader,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Heading,
  Box,
} from '@hawkins/components';

import {
  CalculatorBag,
  CalculatorInputMap,
  CalculatorOutputMap,
  CalculatorInputChangeEventHandler,
  useCalculatorComponents,
} from 'src/domains/calculators';
import { Grid } from 'src/domains/shared/components/Grid';
import styles from './CalculatorRenderer.module.css';

export interface CalculatorRendererProps {
  inputMap: CalculatorInputMap;
  outputMap: CalculatorOutputMap;
  onInputReset: (key: keyof CalculatorOutputMap) => void;
  onInputChange: CalculatorInputChangeEventHandler;
  selectedCalculators: DropdownOption<CalculatorBag>[];
}

export const CalculatorRenderer = ({
  inputMap,
  outputMap,
  onInputReset,
  onInputChange,
  selectedCalculators,
}: CalculatorRendererProps) => {
  const { getComponentsForOption } = useCalculatorComponents({
    inputMap,
    outputMap,
    onInputReset,
    onInputChange,
  });

  return (
    <>
      {selectedCalculators?.map((option) => {
        const components = getComponentsForOption(option);

        return (
          <Card key={option.value.key}>
            <CardHeader>
              <Accordion
                className={
                  styles.calculatorDescriptionAccordionContainer
                }
              >
                <AccordionSummary
                  className={styles.calculatorDescriptionAccordion}
                  title={
                    <Box
                      display="flex"
                      alignItems="center"
                      gap="Space10"
                    >
                      <IconCircleI />
                      <Heading>{option.label}</Heading>
                    </Box>
                  }
                  size="large"
                  hideToggleIcon={true}
                />
                <AccordionDetails>
                  {components.description}
                </AccordionDetails>
              </Accordion>
            </CardHeader>
            <CardBody>
              <Grid gap={Dimensions.Space20}>
                <Grid
                  className={styles.calculatorBody}
                  gap="Space20"
                  justifyItems="center"
                >
                  {components.input}
                  <Divider variant="vertical" />
                  {components.output}
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        );
      })}
    </>
  );
};
